import { Dispatch, SetStateAction, useEffect } from 'react';

import { SendTestMessage } from 'modules/templateEditor/common/Controls';
import { LocaleSwitcher } from 'modules/templateEditor/common/LocaleSwitcher';
import { useSendTestMsgContext } from 'modules/templateEditor/context/SendTestMsgContext';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import { SendTestMsgModals } from 'modules/templateEditor/modals';
import { MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { ALIGNMENT } from 'ui/menu';
import { Spinner } from 'ui/spinner';
import {
  Controls,
  LoadingContainer,
  StyledInStudioEditToolbar,
  PreviewPaneContainer,
} from './InStudioNodeEditorPreview.styles';
import { InStudioTemplateContext } from './InStudioTemplateEditContext';
import { InStudioTemplateProps, SetTemplateEditStateFn } from './InStudioTemplateEditing.types';
import { TemplatePreviewBanner } from './common/components/TemplatePreviewBanner';
import { LastModified } from './common/components/LastModified';
import { ViewOptionsButtonCombo } from './common/components/ViewOptionsButtonCombo';
import { InStudioView } from './common/enums';
import { useEditorViewLoader } from './hooks/useEditorViewLoader';

export const IN_STUDIO_EDIT_TOOLBAR_ID = 'in-studio-node-editor-toolbar';

const PreviewContainer = () => {
  const { isLoading, loadedView: LoadedView } = useEditorViewLoader(InStudioView.Preview);
  if (isLoading || !LoadedView)
    return (
      <LoadingContainer>
        <Spinner />
      </LoadingContainer>
    );

  return (
    <PreviewPaneContainer>
      <LoadedView />
    </PreviewPaneContainer>
  );
};

export interface InStudioNodeEditorPreviewProps extends InStudioTemplateProps {
  campaignId?: number;
  templateId?: number;
  setTemplateEditState: SetTemplateEditStateFn;
  currentLocale?: string;
  setCurrentLocale?: Dispatch<SetStateAction<string | undefined>>;
}

const TemplatePreview = (props: InStudioNodeEditorPreviewProps) => {
  const { onFetchLists } = useSendTestMsgContext();
  const { isLoading } = useTemplateQueryContext();
  useEffect(() => {
    if (!isLoading) onFetchLists();
  }, [isLoading]);
  return (
    <>
      <StyledInStudioEditToolbar data-test={IN_STUDIO_EDIT_TOOLBAR_ID}>
        <Controls>
          <LocaleSwitcher horizontalAlignment={ALIGNMENT.LEFT} isReadOnly={true} />
          <SendTestMessage menuAlignment={MENU_ALIGNMENTS.LEFT} />
        </Controls>
        <ViewOptionsButtonCombo {...props} />
      </StyledInStudioEditToolbar>
      <LastModified />
      <TemplatePreviewBanner />
      <PreviewContainer />
      <SendTestMsgModals />
    </>
  );
};

export default (props: InStudioNodeEditorPreviewProps) => (
  <InStudioTemplateContext {...props}>
    <TemplatePreview {...props} />
  </InStudioTemplateContext>
);
